export default __webpack_public_path__ + "static/media/059-cash.b7f06057.svg";